module.exports = __webpack_public_path__ + "img/20200111125642245.f771c1a2.jpg";